import { render } from "./abgAnalyzer.vue?vue&type=template&id=96e4461e&scoped=true"
import script from "./abgAnalyzer.vue?vue&type=script&lang=js"
export * from "./abgAnalyzer.vue?vue&type=script&lang=js"

import "./abgAnalyzer.vue?vue&type=style&index=0&id=96e4461e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e4461e"]])

export default __exports__